import React from 'react';
import { useParams } from 'react-router';
import { Row, Button } from 'antd';
import { useQuery } from '@apollo/client';
import { Link } from 'components/layout';
import ProjectHeader from '../../ProjectHeader';
import { GET_TEAM } from '../../../../gql/team';
import TeamTable from './components/TeamTable';
import PrivateComponentInProject from '../../../auth/PrivateComponentInProject';
import { PageContainer } from '@ant-design/pro-layout';

const Team = () => {
  const { projectId } = useParams();
  const { data, loading } = useQuery(GET_TEAM, {
    variables: {
      projectId,
    },
  });

  return (
    <ProjectHeader>
      <PageContainer title="Team" loading={loading}>
        <Row>
          <PrivateComponentInProject expectedScopeType={['WRITE_TEAM']}>
            <Button type="primary">
              <Link to={`/projects/${projectId}/team/add`}>
                Add Team Member
              </Link>
            </Button>
          </PrivateComponentInProject>
        </Row>
        <TeamTable data={data} loading={loading} />
      </PageContainer>
    </ProjectHeader>
  );
};

export default Team;
